import { createActionGroup, props } from '@ngrx/store'
import { ViewerPosition, ViewerState } from './viewer.state'
import { ViewerQueryParams } from '../../shared/model/query-params-types'

export const viewerActions = createActionGroup({
    source: 'Viewer',
    events: {
        'Config Loaded': props<{
            config: ViewerState | null
            queryParams: ViewerQueryParams
        }>(),
        'Set Zoom': props<{ zoom: number }>(),
        'Set Position': props<{ position: ViewerPosition }>(),
        'Set Expanded Nodes': props<{ expandedNodes: string[] }>(),
        'Set Layout': props<{ layout: 'xy' | 'xz' | 'yz' | undefined }>(),
        'Set Layer Visibility': props<{ name: string; visible: boolean }>(),
        'Set Layer Opacity': props<{ name: string; opacity: number }>(),
        'Set Layer Opacity Unselected': props<{ name: string; opacity: number }>(),
        'Set Layer Saturation': props<{ name: string; saturation: number }>(),
        'Set Layer Shader Color': props<{ name: string; shaderColor: string }>(),
        'Set Layer Brightness': props<{ name: string; brightness: number }>(),
        'Set Layer Contrast': props<{ name: string; contrast: number }>(),
        'Set Layer Segmentation Color': props<{
            name: string
            segmentationColor: string | undefined
        }>(),
        'Set Search Key': props<{ searchKey: string }>(),
    },
})
